<template>
  <div>
    <vs-divider><h5>Tasks</h5></vs-divider>
    <div v-if="showLoading" class="mx-4">
      <custom-skeleton size="thin__no-margin" :count="1" animation="wave" />
    </div>
    <div v-else class="mx-2">
      <div v-for="_task in taskList" :key="_task.taskId">
        <div style="border-radius: 30px;" class="mb-3 light-gray-border border-3px cursor-pointer" @click.stop="handleSelectedTask(_task)">
          <div class="vx-row p-3">
            <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
              <h4>{{ _task.taskDisplayId }}</h4>
            </div>
            <div class="vx-col w-3/5 text-left" style="padding-left: 1.3rem; padding-right: 0;">
              <div class="vx-row">
                <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                  <p class="mb-1 font-white task-name-heading" style="font-weight: 600;letter-spacing: -2px;line-height: 1.2;">{{_task.taskName}}</p>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full" style="padding-left: 0; padding-right: 0;">
                  <h5 style="color: rgba(var(--vs-warning),1)">{{ _task.statusDisplayName}}</h5>
                </div>
              </div>
            </div>
            <div class="vx-col w-1/5 center-v-h" style="padding-left: 0; padding-right: 0;">
              <custom-svg class="menu--icon arrow--icon" variant="arrow" color="white" dir="right" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomSvg from '@/gen-2/components/CustomSVG.vue';
import 'animate.css'
export default {
  components: {
    CustomSvg
  },
  data() {
    return {
      showLoading: false,
      taskList: [],
    };
  },
  computed: {
    
  },
  methods: {
    getTasks() {
      var self = this;
      self.showLoading = true;

      var onSuccess = function (response) {
        self.taskList = response.data.filter(x => x.statusId == 11 || x.statusId == 12);
      };
      var onFinally = function () {
        self.showLoading = false;
      };

      self.$ajaxGet(self, "Student/ListTasksGen2?moduleId=" + parseInt(self.$route.query.moduleId) + "&taskId=" + parseInt(self.$route.query.taskId), onSuccess, onFinally);
    },
    handleSelectedTask(task) {
      let routeData = this.$router.resolve({ name: 'ViewAssessment', query: { TaskLogId: task.logId } });
      window.open(routeData.href, '_blank');
    },
  },
  mounted() {
    var self = this;

    self.$emit("changeBackgroundColor", "#000000");

    self.currentStudentId = localStorage.getItem("Current_User_Id");

    self.showLoading = true;
    self.getTasks();
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>